import { ProgressHistoryReportDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadProgressHistory = createAction(
  '[ProgressHistory] Load ProgressHistory'
);

export const loadProgressHistorySuccess = createAction(
  '[ProgressHistory] Load ProgressHistory Success',
  props<{ progressHistory: ProgressHistoryReportDto[] }>()
);

export const loadProgressHistoryFailure = createAction(
  '[ProgressHistory] Load ProgressHistory Failure',
  props<{ error: any }>()
);

/**
 * Add Project to Collection Actions
 */
export const addProgressHistory = createAction(
  '[ProgressHistory] Add ProgressHistory',
  props<{ newProgressHistory: ProgressHistoryReportDto[] }>()
);

export const addProgressHistorySuccess = createAction(
  '[ProgressHistory] Add ProgressHistory Success',
  props<{ newProgressHistory: ProgressHistoryReportDto[] }>()
);

export const addProgressHistoryFailure = createAction(
  '[ProgressHistory] Add ProgressHistory Failure',
  props<{ error: any }>()
);

/**
 * Search for record Collection Actions
 */
export const searchProgressHistoryRecord = createAction(
  '[ProgressHistory] Search  ProgressHistory Record',
  props<{ query: string }>()
);

/**
 * Update ProgressHistory Collection Actions
 */
export const updateProgressHistory = createAction(
  '[ProgressHistory] Update ProgressHistory',
  props<{ updateProgressHistory: ProgressHistoryReportDto[] }>()
);

export const updateProgressHistorySuccess = createAction(
  '[ProgressHistory] Update ProgressHistory Success',
  props<{ updateProgressHistory: ProgressHistoryReportDto[] }>()
);

export const updateProgressHistoryFailure = createAction(
  '[ProgressHistory] Update ProgressHistory Failure',
  props<{ error: any }>()
);

/**
 * Remove ProgressHistory Collection Actions
 */
export const removeProgressHistory = createAction(
  '[ProgressHistory] Remove ProgressHistory',
  props<{ ids: string[] }>()
);

export const removeProgressHistorySuccess = createAction(
  '[ProgressHistory] Remove ProgressHistory Success',
  props<{ ids: string[] }>()
);

export const removeProgressHistoryFailure = createAction(
  '[ProgressHistory] Remove ProgressHistory Failure',
  props<{ error: any }>()
);
